import { useContext } from "react";

import {
	OfferContext,
	OfferStore,
	StoreMapping,
	TOfferContext,
} from "@state/context/offer/OfferContext";

/**
 * CURRENTLY MOBILE SPECIFIC HOOK
 * IT WILL BREAK ON LOAD IF IT'S IMPORTED ON DESKTOP
 */
export function useOfferContext<
	T extends keyof StoreMapping = OfferStore.BaseOfferStore,
>(): TOfferContext<T> {
	const offerStore = useContext(OfferContext);

	if (offerStore == null) {
		throw new Error("Offer context does not exist");
	}
	return offerStore as TOfferContext<T>;
}
